import React from "react";
import { Combobox } from "@/components/ui/combobox";
import { US_PRIORITY, OTHER_ZONES } from "@/lib/timezones";

/**
 * Searchable IANA timezone picker.
 *
 *  - US zones bubble to the top under the "United States" heading.
 *  - Every other IANA zone lives under "All timezones" (alphabetical).
 *  - Stores the raw IANA identifier; UI label decoration is display-only.
 */
export default function TimezoneSelect({
    value,
    onChange,
    disabled = false,
    testid = "timezone-select",
    className,
}) {
    const sections = [
        { heading: "United States", options: US_PRIORITY },
        { heading: "All timezones", options: OTHER_ZONES },
    ];
    return (
        <Combobox
            value={value}
            onChange={onChange}
            sections={sections}
            placeholder="Select your timezone"
            searchPlaceholder="Search zones (e.g. Chicago, London)…"
            emptyLabel="No matching timezone."
            testid={testid}
            className={className}
            disabled={disabled}
        />
    );
}
